export default __webpack_public_path__ + "static/media/basketball-icon.f5ec75de.svg";